import { render, staticRenderFns } from "./AccessRequests.vue?vue&type=template&id=c5d2cec2&scoped=true&"
import script from "./AccessRequests.vue?vue&type=script&lang=js&"
export * from "./AccessRequests.vue?vue&type=script&lang=js&"
import style0 from "./AccessRequests.vue?vue&type=style&index=0&id=c5d2cec2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d2cec2",
  null
  
)

export default component.exports